module.exports = __webpack_public_path__ + "static/media/dorp.0c6781df.jpg";